async function requestJson(path, options = {}) {
  const response = await fetch(path, {
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...options.headers,
    },
    ...options,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}

function buildParams(filters = {}) {
  const params = new URLSearchParams();
  if (filters.search) params.set("search", filters.search);
  if (filters.isActive !== undefined && filters.isActive !== "") {
    params.set("is_active", String(filters.isActive));
  }
  if (filters.vehicleMakeId) params.set("vehicle_make_id", filters.vehicleMakeId);
  if (filters.vehicleModelId) params.set("vehicle_model_id", filters.vehicleModelId);
  if (filters.lookupType) params.set("lookup_type", filters.lookupType);
  return params.toString();
}

async function listLookup(path, filters) {
  const query = buildParams(filters);
  const data = await requestJson(
    `/api/admin/mobility/vehicle-lookups/${path}${query ? `?${query}` : ""}`
  );
  return data.items || [];
}

export const fetchVehicleMakes = (f) => listLookup("makes", f);
export const fetchVehicleModels = (f) => listLookup("models", f);
export const fetchVehicleTrims = (f) => listLookup("trims", f);
export const fetchVehicleBodyTypes = (f) => listLookup("body-types", f);
export const fetchVehicleFuelTypes = (f) => listLookup("fuel-types", f);
export const fetchVehicleTransmissions = (f) => listLookup("transmissions", f);
export const fetchVehicleClasses = (f) => listLookup("classes", f);
export const fetchVehicleLookupAliases = (f) => listLookup("aliases", f);

async function mutateLookup(path, method, payload, id) {
  const url = id
    ? `/api/admin/mobility/vehicle-lookups/${path}/${encodeURIComponent(id)}`
    : `/api/admin/mobility/vehicle-lookups/${path}`;
  const data = await requestJson(url, {
    method,
    body: JSON.stringify(payload),
  });
  return data.item;
}

export const createVehicleMake = (p) => mutateLookup("makes", "POST", p);
export const updateVehicleMake = (id, p) => mutateLookup("makes", "PATCH", p, id);
export const createVehicleModel = (p) => mutateLookup("models", "POST", p);
export const updateVehicleModel = (id, p) => mutateLookup("models", "PATCH", p, id);
export const createVehicleTrim = (p) => mutateLookup("trims", "POST", p);
export const updateVehicleTrim = (id, p) => mutateLookup("trims", "PATCH", p, id);
export const createVehicleBodyType = (p) => mutateLookup("body-types", "POST", p);
export const updateVehicleBodyType = (id, p) => mutateLookup("body-types", "PATCH", p, id);
export const createVehicleFuelType = (p) => mutateLookup("fuel-types", "POST", p);
export const updateVehicleFuelType = (id, p) => mutateLookup("fuel-types", "PATCH", p, id);
export const createVehicleTransmission = (p) => mutateLookup("transmissions", "POST", p);
export const updateVehicleTransmission = (id, p) =>
  mutateLookup("transmissions", "PATCH", p, id);
export const createVehicleClass = (p) => mutateLookup("classes", "POST", p);
export const updateVehicleClass = (id, p) => mutateLookup("classes", "PATCH", p, id);
export const createVehicleLookupAlias = (p) => mutateLookup("aliases", "POST", p);
export const updateVehicleLookupAlias = (id, p) => mutateLookup("aliases", "PATCH", p, id);

export async function fetchPublicVehicleLookups() {
  const data = await requestJson("/api/mobility/vehicle-lookups");
  return data.lookups;
}
